import { create } from 'zustand';

type AppointmentStatus = 'SCHEDULED' | 'PORTAL_BOOKED' | 'CHECKED_IN' | 'COMPLETED' | 'CANCELLED' | 'NO_SHOW';

type AppointmentData = {
    id?: string;
    patientId: string;
    providerId: string;
    status: AppointmentStatus;
    appointmentTypeId: string;
    start: string;
    durationMinutes: number;
    title: string;
    isTelemed?: boolean;
    generateTelemedLink?: boolean;
    joinUrl?: string | null;
    medicalFormTemplateIds?: string[];
    [key: string]: any; // Allow other properties
};

type AppointmentModalStore = {
    isOpen: boolean;
    pendingData: AppointmentData | null;
    openModal: (data?: Partial<AppointmentData>) => void;
    closeModal: () => void;
};

const defaultData: AppointmentData = {
    patientId: '',
    providerId: '',
    status: 'SCHEDULED',
    appointmentTypeId: '',
    start: new Date().toISOString().slice(0, 16),
    durationMinutes: 30,
    title: '',
    isTelemed: false,
    generateTelemedLink: false,
    joinUrl: null,
    medicalFormTemplateIds: [],
};

export const useAppointmentModalStore = create<AppointmentModalStore>((set) => ({
    isOpen: false,
    pendingData: null,
    openModal: (data) =>
        set({
            isOpen: true,
            pendingData: { ...defaultData, ...data },
        }),
    closeModal: () => set({ isOpen: false, pendingData: null }),
}));
